import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {MatPaginator, MatPaginatorModule} from '@angular/material/paginator';
import {ActivatedRoute, Params} from '@angular/router';
import {MatSort, Sort} from '@angular/material/sort';
import {PropertiesService} from '../../../../admin-services/properties.service';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgbModal, NgbModalRef, NgbPopoverModule} from '@ng-bootstrap/ng-bootstrap';
import {ProcessSharedService} from 'src/app/services/process-shared.service';
import {AdminProcessService} from 'src/app/admin/admin-services/admin-process.service';
import {HttpClient, HttpHeaders, HttpRequest} from '@angular/common/http';
import {AlertService} from 'src/app/services/alert.service';
import {GlobalConstantsComponent} from 'src/app/shared/global-constants/global-constants.component';
import {DomSanitizer} from '@angular/platform-browser';
import {AuthenticationService} from 'src/app/services/authentication.service';
import {UserService} from '../../../../../services/user-services/user.service';
import {Select2Module} from 'ng-select2-component';
import {DragDropDirective} from '../../../../../directives/drag-drop.directive';
import {ItemBadgesComponent} from '../../../../../shared/components/item-badges/item-badges.component';
import {MatIconModule} from '@angular/material/icon';
import {CheckImageUrlDirective} from '../../../../../directives/check-image-url.directive';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatOptionModule} from '@angular/material/core';
import {MatSelectModule} from '@angular/material/select';
import {MatFormFieldModule} from '@angular/material/form-field';
import {DatePipe, NgClass, NgFor, NgIf, TitleCasePipe} from '@angular/common';
import {NgxIntlTelInputModule} from '@justin-s/ngx-intl-tel-input';
import {MatInput} from '@angular/material/input';
import {MatRadioButton, MatRadioGroup} from '@angular/material/radio';
import {TranslateModule} from '@ngx-translate/core';
import {MatCheckbox} from '@angular/material/checkbox';
import {take} from 'rxjs/operators';
import {NumberOnlyDirective} from '../../../../../directives/numberOnly.directive';
import {IconComponent} from '../../../../../shared/components/icons-svgs/icons-svgs.component';
import {HelperService} from '../../../../../services/helper.service';
import {saveAs} from 'file-saver';
import {PlatformService} from "../../../../../services/platform-service.service";
import { RoundPipe } from 'src/app/helpers/round.pipe';
import { LocalSettingsService } from 'src/app/services/local-settings.service';


@Component({
  selector: 'app-properties',
  templateUrl: './properties.component.html',
  styleUrls: ['./properties.component.scss'],
  standalone: true,
  imports: [FormsModule, NgxIntlTelInputModule, NgIf, MatFormFieldModule, NgClass, MatSelectModule, ReactiveFormsModule, MatOptionModule, NgFor, MatDatepickerModule, Select2Module, MatTableModule, CheckImageUrlDirective, MatIconModule, NgbPopoverModule, ItemBadgesComponent, MatPaginatorModule, DragDropDirective, DatePipe, MatInput, MatRadioButton, MatRadioGroup, TranslateModule, MatCheckbox, NumberOnlyDirective, TitleCasePipe, IconComponent, RoundPipe]
})
export class PropertiesComponent implements OnInit, AfterViewInit, OnDestroy {


  dataSource;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('loadingModal') loadingModal: TemplateRef<any>;
  private loadingModalRef: NgbModalRef;
  isprogress = false;
  progressValue = 0;
  displayedColumns: string[] = ['property', 'partner', 'progress', 'action'];
  displayedProperties;
  hasChangedFilter;
  dispPrFilter;
  dispDateFilter = false;
  dispChargesDropDown = false;
  dispVerifDropDown = false;
  dispoFilter = null;
  checkVVFilter = 'unsetted';
  checkPhotosFilter = 'unsetted';
  checkWCNbFilter = 'unsetted';
  checkBathroomPrvFilter = 'unsetted';
  checkWCPrvFilter = 'unsetted';
  checkBathroomNbFilter = 'unsetted';
  selectAll = false;
  selectPhotos = false;
  selectedElements: any[] = [];
  selectedPhotos: any[] = [];
  selectedChargesFilters = [];
  showMoreFilters = false;
  filteredList;
  ppties = [];
  pptiesIds = [];
  type = [];
  currentDate: string;
  photoChecked = false;
  dispoChecked = false;
  infosChecked = false;
  travauxChecked = false;
  notFoundChecked = false;
  selectedDate = null;
  commentaire = '';
  autreChecked = false;
  dispoDate;
  bLoyer;
  promoReduc;
  startDatePromo;
  endDatePromo;
  typeReduc;
  isFeatured;
  bHono;
  bCharges;
  partnerFees;
  deposit;
  bypassDate;
  bypassCommentary;
  tenant;
  eraseTanent = false;
  badgeSelected;
  isLoading;
  public dispoArray = [
    {name: 'Tous', value: null},
    {name: 'Date connue', value: 'setted'},
    {name: 'Date inconnue', value: 'unsetted'},
    {name: 'Plage de date', value: 'date'}
  ];
  public checkVV = [
    {name: 'N/A', value: 'unsetted'},
    {name: 'Oui', value: 'true'},
    {name: 'Non', value: 'false'},
  ];

  sortFirstColumn = {
    name: {active: 'name', direction: ''},
    id: {active: 'id', direction: ''},
    city: {active: 'city', direction: ''},
    partnerRef: {active: 'partnerRef', direction: ''},
    date: {active: 'date', direction: ''},
    isVerified: {active: 'isVerified', direction: ''},
    dateDispo: {active: 'dateDispo', direction: ''}
  };
  public isResettingPhotos: boolean = false;

  public cityFilter: FormControl = new FormControl<string | null>(null);
  public subCityFilter: FormControl = new FormControl<string | null>(null);
  public partnerFilter: FormControl = new FormControl<string | null>(null);
  public minPriceFilter: FormControl = new FormControl<string | null>(null);
  public maxPriceFilter: FormControl = new FormControl<string | null>(null);
  public statusFilter: FormControl = new FormControl<string | null>(null);
  public blockedFilter: FormControl = new FormControl<string | null>(null);
  public blockedReasonFilter: FormControl = new FormControl<string | null>(null);
  public blockedByFilter: FormControl = new FormControl<string | null>(null);
  public bypassFilter: FormControl = new FormControl<string | null>(null);
  public bypassReasonFilter: FormControl = new FormControl<string | null>(null);
  public bypassByFilter: FormControl = new FormControl<string | null>(null);
  public badgesFilter: FormControl = new FormControl<string | null>(null);
  public sortBy: FormControl = new FormControl<string | null>(null);
  public typeFilter: FormControl = new FormControl<string | null>(null);
  public nbRoomsFilter: FormControl = new FormControl<string | null>(null);
  public colocSizeFilter: FormControl = new FormControl<string | null>(null);
  public minDurationFilter: FormControl = new FormControl<string | null>(null);
  public bathroomFilter: FormControl = new FormControl<string | null>(null);
  public wcFilter: FormControl = new FormControl<string | null>(null);
  public genderFilter: FormControl = new FormControl<string | null>(null);
  public chargesFilter: FormControl = new FormControl<string | null>(null);
  public badgeFC: FormControl = new FormControl<string | null>(null);
  public typePromoFC: FormControl = new FormControl<string | null>(null);
  public contactFilter: FormControl = new FormControl<string | null>(null);
  public photoFilter: FormControl = new FormControl<string | null>(null);
  public countryFilter: FormControl = new FormControl<string | null>(null);
  public featuredFilter: FormControl = new FormControl<string | null>(null);
  public isStudentResidenceFilter: FormControl = new FormControl<string | null>(null);


  citySelectList;
  subCitySelectList;
  contactSelectList;

  dateRange = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  editPpty;
  draggingIndex;
  propertyPhotosList;
  fileName: string;
  uploadId: string;
  searchVal;
  agents;
  params;
  currentAgent;
  statusList = [{value: 'Disponible', name: 'Disponible'}, {value: 'Non disponible', name: 'Non disponible'},
    {value: 'Réservée', name: 'Réservé'},
  ];
  chargesList = [{value: 'électricité', name: 'Electricité', checked: false}, {value: 'gaz', name: 'Gaz', checked: false}, {
    value: 'eau',
    name: 'Eau',
    checked: false
  },
    {value: 'wifi', name: 'Wifi', checked: false}, {value: 'ménage', name: 'Ménage', checked: false}
  ];
  blockList = ['Photo', 'Infos', 'Dispo', 'Travaux', '404', 'Autre'];
  private apiUrl = GlobalConstantsComponent.apiURL;
  public badgesList = [{value: 'none', name: 'Aucun'}, {value: 'isLocated', name: 'Bien placé'},
    {value: 'isPopular', name: 'Populaire'}, {value: 'isPromoted', name: 'Promotion'}];

  public bypassFilterList = ['Honoraires', 'Charges','Frais partenaire', 'Dispo', 'Dépôt garantie', 'Loyer'];

  public typePromoList = [{value: 'owner', name: 'Honoraires bailleur'},
    {value: 'livinfrance', name: 'Honoraires LivinFrance'}];

  public properties = [];
  public blockByList: any[] = [];
  public partnerList: string[] = [];
  public byPassList: any[] = [];
  public otherRooms: any[] = [];
  public numbers: number[] = [];

  public photoVerifiedList = [
    {value: 'null', name: 'Non vérifiée'},
    {value: 'verified', name: 'Vérifiée'},
    {value: 'logo', name: 'Non vérifiée - Logo'}, {value: 'desordered', name: 'Non vérifiée - Désordre'},
    {value: 'noPhoto', name: 'Non vérifiée - Pas de photo'}, {value: 'other', name: 'Non vérifiée - Autre'}];
  public searched = false;
  public windowTopScrolled = false;
  public windowBottomScrolled = true;
  private scrollPercentage: number;
  currentLanguage: string;


  constructor(
    private carePropertiesService: PropertiesService,
    private modalService: NgbModal,
    private processSharedService: ProcessSharedService,
    private adminProcessService: AdminProcessService,
    private http: HttpClient,
    private alertService: AlertService,
    private sanitizer: DomSanitizer,
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private route: ActivatedRoute,
    private helperService: HelperService,
    private platformService: PlatformService,
    private el: ElementRef,
    private localSettings: LocalSettingsService

  ) {
  }

  ngOnInit() {

    this.localSettings.language$.subscribe(
      (language: string) => {
        this.currentLanguage = language;
      }
    );

    this.route.queryParams.subscribe((params: Params) => {
      this.params = params.id_property;
    });

    for (let i = 0; i <= 10; i++) {
      this.numbers.push(i);
    }

    this.fetchProperties();

    this.currentAgent = this.userService.getInfos();
    this.processSharedService.getAdminAgents().subscribe((data) => {
      this.agents = data;
      const today = new Date();
      this.currentDate = today.toISOString().slice(0, 10);

      if (this.params) {
        this.searchVal = this.params;
        this.applyFilter();
      }
    });
  }

  ngAfterViewInit() {
    const margingLayout = document.getElementsByClassName('page_content')[0];
    if (margingLayout) {
      margingLayout.classList.add('my-0');
    }
    if(this.platformService.isBrowserPlatform()){
      const page_listener = document.querySelector('.page_listener');
      page_listener.addEventListener('scroll', () => {
        this.windowTopScrolled = page_listener.scrollTop !== 0;
        const scrollHeight = page_listener.scrollHeight;
        const clientHeight = page_listener.clientHeight;
        this.scrollPercentage = (page_listener.scrollTop / (scrollHeight - clientHeight)) * 100;
        this.windowBottomScrolled = this.scrollPercentage !== 100;

      });
    }
  }

  ngOnDestroy() {
    const margingLayout = document.getElementsByClassName('page_content')[0];
    if (margingLayout) {
      margingLayout.classList.remove('my-0');
    }
  }

  fetchInfo(ppty) {
    const c = ppty.property_photos.filter(x => x.cover_photo == 1);
    ppty['cover_photo'] = c[0].photo;
    ppty['nb_images'] = ppty.property_photos.length;

    // Changement de statut
    if (!ppty.redirect) {
      if (
        !ppty.virtualVisitVerified ||
        ppty.photosVerified !== 'verified' ||
        !ppty.wcVerified ||
        !ppty.bathroomVerified ||
        (ppty.wc_private == 0 && !ppty.nbWc) ||
        (ppty.bathrooms_private == 0 && !ppty.nbBathroom)
      ) {
        ppty.isVerified = 0;
      } else {
        ppty.isVerified = 1;
      }

      if (ppty.promotionDatas) {
        ppty.promotionDatas = JSON.parse(ppty.promotionDatas);
      }
      if (ppty.badges) {
        ppty.badges = JSON.parse(ppty.badges);
      }
      return ppty;
    }
  }

  fetchProperties() {
    this.properties = [];
    this.partnerList = [];
    this.carePropertiesService.getProperties()
      .pipe(take(1))
      .subscribe((data) => {
        data.forEach(d => {
          // Check la photo
          const c = d.property_photos.filter(x => x.cover_photo == 1);
          d['cover_photo'] = c[0].photo;
          d['nb_images'] = d.property_photos.length;

          // Changement de statut
          if (!d.redirect) {
            if (
              !d.virtualVisitVerified ||
              d.photosVerified !== 'verified' ||
              !d.wcVerified ||
              !d.bathroomVerified ||
              (d.wc_private == 0 && !d.nbWc) ||
              (d.bathrooms_private == 0 && !d.nbBathroom)
            ) {
              d.isVerified = 0;
            } else {
              d.isVerified = 1;
            }

            if (d.promotionDatas) {
              d.promotionDatas = JSON.parse(d.promotionDatas);
            }
            if (d.badges) {
              d.badges = JSON.parse(d.badges);
            }

            // Récupère la liste des gens qui ont bloqué une propriété
            if (d.forceBlocked_datas) {
              d.forceBlocked_datas = JSON.parse(d.forceBlocked_datas);
              this.updateBlockByList(d.forceBlocked_datas);
            }

            // Récupère la liste des gens qui ont byPass une propriété
            if (d.bypassDatas) {
              d.bypassDatas = JSON.parse(d.bypassDatas);
              this.updateByPassList(d.bypassDatas);
            }
            // Liste des partenaires
            if (d.partner && this.partnerList.indexOf(d.partner.name) === -1) {
              this.partnerList.push(d.partner.name);
            }

            // Add item in array
            this.properties.push(d);
          }
        });
        this.tabUpdate(this.properties);
        this.partnerList.sort((a, b) => a.localeCompare(b));
        this.blockByList.sort((a, b) => a.lastname.localeCompare(b.lastname));
      });
  }

  public trackByIndex(index, item): number {
    return index;
  }

  public trackById(index, item): number {
    return item.id;
  }

  applyFilter() {
    let filterValue = this.searchVal.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    const t = [];
    const prefilteredList = this.filteredList ? this.filteredList : this.properties;
    prefilteredList.forEach(element => {
      if (
        element.partner_ref.toLowerCase().includes(filterValue)
        || element.partner_id.toLowerCase() == filterValue
        || element.name.toLowerCase().includes(filterValue)
        || element.partner.name.toString().includes(filterValue)
        || (element.link && element.link.toString() == filterValue)
        || element.id == filterValue
      ) {
        t.push(element);
      }
    });
    this.tabUpdate(t);
  }

  checkEmptySearch() {
    if (this.searchVal === '' && this.searched) {
      this.applyFilter();
      this.searched = false;
    }
  }

  returnUrl(element) {
    if (!element.redirect) {
      return window.location.protocol + '//' + window.location.host + '/accommodation/property/' + element.id;
    }
    return element.link;
  }

  fillSelectCity() {
    this.citySelectList = this.getCityList(this.properties);
  }

  fillSelectsubCity() {
    this.subCitySelectList = this.getSubCityList(this.properties);
  }

  fillSelectContact() {
    this.contactSelectList = this.getContactList(this.properties);
  }

  printStatus(property) {
    if (property.tenant && property.status == 'Unlisted') {
      return 'Réservée';
    } else if (property.disponibility && property.status == 'Listed') {
      return 'Disponible';
    }
    return 'Non disponible';
  }


  tabUpdate(table) {
    this.dataSource = new MatTableDataSource<any>(table);
    this.dataSource.paginator = this.paginator;
    this.displayedProperties = table;
  }

  sortData(sort: Sort) {
    if (sort.active === 'name' || sort.active === 'id' || sort.active === 'city' || sort.active === 'partnerRef' || sort.active === 'date' || sort.active == 'isVerified' || sort.active === 'dateDispo') {
      if (this.sortFirstColumn[sort.active].direction === '') {
        this.sortFirstColumn[sort.active].direction = 'asc';
      } else if (this.sortFirstColumn[sort.active].direction === 'asc') {
        this.sortFirstColumn[sort.active].direction = 'desc';
      } else {
        this.sortFirstColumn[sort.active].direction = '';
      }
      if (sort.active === 'name') {
        this.sortFirstColumn.id.direction = '';
        this.sortFirstColumn.city.direction = '';
      }
      if (sort.active === 'id') {
        this.sortFirstColumn.name.direction = '';
        this.sortFirstColumn.city.direction = '';
      }
      if (sort.active === 'city') {
        this.sortFirstColumn.name.direction = '';
        this.sortFirstColumn.id.direction = '';
      }
      if (sort.active === 'isVerified') {
        this.sortFirstColumn.name.direction = '';
        this.sortFirstColumn.id.direction = '';
      }
      sort.active = this.sortFirstColumn[sort.active].active;
      sort.direction = this.sortFirstColumn[sort.active].direction;
    } else {
      this.sortFirstColumn.name.direction = '';
      this.sortFirstColumn.id.direction = '';
      this.sortFirstColumn.city.direction = '';
    }
    const data = this.displayedProperties.slice();
    // Par défaut, les chambres sont triées par id
    if (!sort.active || sort.direction === '') {
      sort.active = 'id';
      sort.direction = 'asc';
    }
    const result = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'partner':
          return this.compare(a.contact.id, b.contact.id, isAsc);
        case 'progress':
          return this.compare(a.pourcent, b.pourcent, isAsc);
        case 'status':
          return this.compare(a.status, b.status, isAsc);
        case 'name':
          return this.compare(a.name, b.name, isAsc);
        case 'id':
          return this.compare(a.id, b.id, isAsc);
        case 'city':
          return this.compare(a.city_group, b.city_group, isAsc);
        case 'partnerRef':
          return this.compare(a.partner_ref, b.partner_ref, isAsc);
        case 'date':
          return this.compare(a.created_at, b.created_at, isAsc);
        case 'isVerified':
          return this.compare(a.isVerified, b.isVerified, isAsc);
        case 'dateDispo':
          return this.compare(a.disponibility, b.disponibility, isAsc);
        default:
          return 0;
      }
    });
    this.tabUpdate(result);
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  getCityList(ppties) {
    let d = [];
    let d2 = [];
    ppties.forEach(element => {
      d.push(element.city_group);
    });
    d = [...new Set(d)];
    d = d.filter(function(val) {
      return val != null;
    });
    d.sort((a, b) => a.localeCompare(b));
    d.forEach(element => {
      d2.push({value: element, label: element});
    });
    return d2;
  }

  getContactList(ppties) {
    let d = [];
    let d2 = [];
    ppties.forEach(element => {
      if (element.contact && element.contact.name && element.contact.society) {
        d.push(element.contact.name + ' - ' + '(' + element.contact.society + ')');
      }
    });
    d = [...new Set(d)];
    d = d.filter(function(val) {
      return val != null;
    });
    d.sort((a, b) => a.localeCompare(b));
    d.forEach(element => {
      d2.push({value: element, label: element});
    });
    return d2;
  }

  doFilter() {
    // ferme les custom dropdown
    this.dispVerifDropDown = false;
    this.dispChargesDropDown = false;

    let t1 = [];
    let t2 = [];
    let t3 = [];
    let t4 = [];
    let t5 = [];
    let t6 = [];
    let t7 = [];
    let t8 = [];
    let t9 = [];
    let t10 = [];
    let t11 = [];
    let t12 = [];
    let t13 = [];
    let t14 = [];
    let t15 = [];
    let t16 = [];
    let t17 = [];
    let t18 = [];
    let t19 = [];
    let t20 = [];
    let t21 = [];
    let t22 = [];
    let t23 = [];
    let t24 = [];
    let t25 = [];
    let t26 = [];
    let t27 = [];
    let t28 = [];
    let t29 = [];
    let t30 = [];
    let t31 = [];
    let t32 = [];
    let t33 = [];

    if (this.cityFilter.value) {
      this.properties.forEach(element => {
        if (element.city_group == this.cityFilter.value) {
          t1.push(element);
        }
      });
    } else {
      t1 = this.properties;
    }

    if (this.partnerFilter.value) {
      t1.forEach(element => {
        if (element.partner.name == this.partnerFilter.value) {
          t2.push(element);
        }
      });
    } else {
      t2 = t1;
    }

    if (this.minPriceFilter.value) {
      t2.forEach(element => {
        if ((element.price + element.charges_amount) >= this.minPriceFilter.value) {
          t3.push(element);
        }
      });
    } else {
      t3 = t2;
    }

    if (this.maxPriceFilter.value) {
      t3.forEach(element => {
        if ((element.price + element.charges_amount) <= this.maxPriceFilter.value) {
          t4.push(element);
        }
      });
    } else {
      t4 = t3;
    }

    if (this.statusFilter.value) {
      t4.forEach(element => {
        if (this.printStatus(element) == this.statusFilter.value) {
          t5.push(element);
        }
      });
    } else {
      t5 = t4;
    }

    if (this.blockedFilter.value) {
      t5.forEach(element => {
        if (this.blockedFilter.value == '1') {
          if (element.forceBlocked) {
            t6.push(element);
          }
        } else {
          if (!element.forceBlocked) {
            t6.push(element);
          }
        }
      });
    } else {
      t6 = t5;
    }

    if (this.bypassFilter.value) {
      t6.forEach(element => {
        if (this.bypassFilter.value == '1') {
          if (element.bypass_feed) {
            t7.push(element);
          }
        } else {
          if (!element.bypass_feed) {
            t7.push(element);
          }
        }
      });
    } else {
      t7 = t6;
    }

    if (this.dispoFilter) {
      t7.forEach(element => {
        if (this.dispoFilter == 'setted' && element.disponibility) {
          t8.push(element);
        }
        if (this.dispoFilter == 'unsetted' && !element.disponibility) {
          t8.push(element);
        }
        if (this.dispoFilter == 'date' && element.disponibility) {
          const d = new Date(element.disponibility);
          if (this.dateRange.value.start && !this.dateRange.value.end) {
            if (d >= this.dateRange.value.start) {
              t8.push(element);
            }
          }
          if (this.dateRange.value.end && !this.dateRange.value.start) {
            if (d <= this.dateRange.value.end) {
              t8.push(element);
            }
          }
          if (this.dateRange.value.start && this.dateRange.value.end) {
            if (d >= this.dateRange.value.start && d <= this.dateRange.value.end) {
              t8.push(element);
            }
          }
        }
      });
    } else {
      t8 = t7;
    }

    if (this.subCityFilter.value) {
      t8.forEach(element => {
        if (element.city == this.subCityFilter.value) {
          t9.push(element);
        }
      });
    } else {
      t9 = t8;
    }

    if (this.typeFilter.value) {
      t9.forEach(element => {
        if (this.typeFilter.value == 'apartment') {
          if (element.partner_type == 'apartment') {
            t10.push(element);
          }
        } else {
          if (element.partner_type != 'apartment') {
            t10.push(element);
          }
        }
      });
    } else {
      t10 = t9;
    }

    if (this.nbRoomsFilter.value) {
      t10.forEach(element => {

        if (this.nbRoomsFilter.value === '8+') {
          if (element.dispoInHouse > 8) {
            t11.push(element);
          }
        } else {
          if (element.dispoInHouse >= this.nbRoomsFilter.value) {
            t11.push(element);
          }
        }
      });
    } else {
      t11 = t10;
    }

    if (this.colocSizeFilter.value) {
      t11.forEach(element => {
        if (this.colocSizeFilter.value == 'small') {
          if (element.nbRooms <= 5) {
            t12.push(element);
          }
        }
        if (this.colocSizeFilter.value == 'big') {
          if (element.nbRooms >= 6) {
            t12.push(element);
          }
        }
      });
    } else {
      t12 = t11;
    }

    if (this.minDurationFilter.value) {
      t12.forEach(element => {
        let duration: number;
        if(element.minimal_stay_duration){
          duration = element.minimal_stay_duration;
        }
        else{
          duration = element.partner.reservation_min * 30;
        }
        if (this.minDurationFilter.value == '2') {
          if (duration <= 60) {
            t13.push(element);
          }
        }
        if (this.minDurationFilter.value == '6') {
          if (duration > 60 && duration <= 180) {
            t13.push(element);
          }
        }
        if (this.minDurationFilter.value == '12') {
          if (duration > 180) {
            t13.push(element);
          }
        }
      });
    } else {
      t13 = t12;
    }

    if (this.bathroomFilter.value) {
      t13.forEach(element => {
        if (this.bathroomFilter.value == '1') {
          if (element.bathrooms_private == 1) {
            t14.push(element);
          }
        } else {
          if (element.bathrooms_private != 1) {
            t14.push(element);
          }
        }
      });
    } else {
      t14 = t13;
    }

    if (this.wcFilter.value) {
      t14.forEach(element => {
        if (this.wcFilter.value == '1') {
          if (element.wc_private == 1) {
            t15.push(element);
          }
        } else {
          if (element.wc_private != 1) {
            t15.push(element);
          }
        }
      });
    } else {
      t15 = t14;
    }

    if (this.genderFilter.value) {
      t15.forEach(element => {
        if (this.genderFilter.value == 'M') {
          if (element.tenants_gender == 'M') {
            t16.push(element);
          }
        }
        if (this.genderFilter.value == 'F') {
          if (element.tenants_gender == 'F') {
            t16.push(element);
          }
        }
      });
    } else {
      t16 = t15;
    }
    if (this.selectedChargesFilters.length) {
      this.selectedChargesFilters.forEach(filter => {
        t16.forEach(element => {
          if (element.charges) {
            if (typeof element.charges === 'string') {
              element.c = JSON.parse(element.charges);
            } else {
              element.c = element.charges;
            }
            if (element.c.includes(filter.value)) {
              if (t17.indexOf(element) === -1) {
                t17.push(element);
              }
            }
          }

        });

      });
    } else {
      t17 = t16;
    }

    if (this.checkVVFilter != 'unsetted') {
      t17.forEach(element => {
        if (element.virtualVisitVerified && this.checkVVFilter == 'true') {
          t18.push(element);
        }
        if (!element.virtualVisitVerified && this.checkVVFilter == 'false') {
          t18.push(element);
        }
      });
    } else {
      t18 = t17;
    }

    if (this.checkPhotosFilter != 'unsetted') {
      t18.forEach(element => {
        if (element.photosVerified === 'verified' && this.checkPhotosFilter == 'true') {
          t19.push(element);
        }
        if (element.photosVerified !== 'verified' && this.checkPhotosFilter == 'false') {
          t19.push(element);
        }
      });
    } else {
      t19 = t18;
    }

    if (this.checkWCNbFilter != 'unsetted') {
      t19.forEach(element => {
        if (element.nbBathroom && this.checkWCNbFilter == 'true') {
          t20.push(element);
        }
        if (!element.nbBathroom && this.checkWCNbFilter == 'false') {
          t20.push(element);
        }
      });
    } else {
      t20 = t19;
    }

    if (this.checkBathroomPrvFilter != 'unsetted') {
      t20.forEach(element => {
        if (element.bathroomVerified && this.checkBathroomPrvFilter == 'true') {
          t21.push(element);
        }
        if (!element.bathroomVerified && this.checkBathroomPrvFilter == 'false') {
          t21.push(element);
        }
      });
    } else {
      t21 = t20;
    }

    if (this.checkWCPrvFilter != 'unsetted') {
      t21.forEach(element => {
        if (element.wcVerified && this.checkWCPrvFilter == 'true') {
          t22.push(element);
        }
        if (!element.wcVerified && this.checkWCPrvFilter == 'false') {
          t22.push(element);
        }
      });
    } else {
      t22 = t21;
    }

    if (this.checkBathroomNbFilter != 'unsetted') {
      t22.forEach(element => {
        if (element.nbBathroom && this.checkBathroomNbFilter == 'true') {
          t23.push(element);
        }
        if (!element.nbBathroom && this.checkBathroomNbFilter == 'false') {
          t23.push(element);
        }
      });
    } else {
      t23 = t22;
    }

    if (this.badgesFilter.value) {
      t23.forEach(element => {
        if (this.badgesFilter.value === 'none') {
          if (!element.badges || Object.values(element.badges).every(badge => badge !== 1)) {
            t24.push(element);
          }
        } else {
          if (element.badges) {
            let badges = element.badges;
            let value_badge = badges[this.badgesFilter.value];
            if (value_badge == 1) {
              t24.push(element);
            }
          }
        }
      });
    } else {
      t24 = t23;
    }

    if (this.blockedReasonFilter.value) {
      t24.forEach(element => {
        if (element.forceBlocked_datas) {
          let blockedDatas = element.forceBlocked_datas;
          if (blockedDatas['typeOfBlock'] && blockedDatas['typeOfBlock'].includes(this.blockedReasonFilter.value)) {
            t25.push(element);
          }
        }
      });
    } else {
      t25 = t24;
    }

    if (this.blockedByFilter.value) {
      t25.forEach(element => {
        if (element.forceBlocked_datas) {
          let blockedDatas = element.forceBlocked_datas.blockedBy;
          if (blockedDatas['id'] && (blockedDatas['id'] == this.blockedByFilter.value)) {
            t26.push(element);
          }
        }
      });
    } else {
      t26 = t25;
    }

    if (this.bypassReasonFilter.value) {
      t26.forEach(element => {
        if (element.bypassDatas) {
          let typeOfBypass = element.bypassDatas.typeOfBypass;
          if (typeOfBypass && typeOfBypass === this.bypassReasonFilter.value) {
            t27.push(element);
          }
        }
      });
    } else {
      t27 = t26;
    }

    if (this.bypassByFilter.value) {
      t27.forEach(element => {
        if (element.bypassDatas) {
          let bypassDatas = element.bypassDatas.bypassBy;
          if (bypassDatas['id'] && (bypassDatas['id'] === this.bypassByFilter.value)) {
            t28.push(element);
          }
        }
      });
    } else {
      t28 = t27;
    }

    if (this.contactFilter.value) {
      t28.forEach(element => {
        if (element.contact && element.contact.name === this.contactFilter.value.split(' - ')[0]) {
          t29.push(element);
        }
      });
    } else {
      t29 = t28;
    }
    if (this.photoFilter.value) {
      t29.forEach(element => {
        if ((element.cover_photo === '' || element.cover_photo.includes('pictures_coming_soon.png')) && this.photoFilter.value === 'sans') {
          t30.push(element);
        }
        if ((element.cover_photo !== '' && !element.cover_photo.includes('pictures_coming_soon.png')) && this.photoFilter.value === 'avec') {
          t30.push(element);
        }
      });
    } else {
      t30 = t29;
    }
    if (this.featuredFilter.value) {
      t30.forEach(element => {
        if (element.is_featured == this.featuredFilter.value) {
          t31.push(element);
        }
      });
    } else {
      t31 = t30;
    }
    if (this.countryFilter.value) {
      t31.forEach(element => {
        if ((element.country.toLowerCase() === 'fr' || element.country.toLowerCase() === 'franc') && element.city.toLowerCase() !== 'bruxelles' && element.city.toLowerCase() !== 'berlin' && this.countryFilter.value === 'fr') {
          t32.push(element);
        }
      });
    } else {
      t32 = t31;
    }
    if (this.isStudentResidenceFilter.value !== null) {
      t32.forEach(element => {
        if (element.isStudentResidence == this.isStudentResidenceFilter.value) {
          t33.push(element);
        }
      });
    } else {
      t33 = t32;
    }

    this.filteredList = t33;
    this.tabUpdate(t33);
    return true;
  }

  clearFilter() {
    this.cityFilter.reset();
    this.subCityFilter.reset();
    this.partnerFilter.reset();
    this.contactFilter.reset();
    this.minPriceFilter.reset();
    this.maxPriceFilter.reset();
    this.statusFilter.reset();
    this.blockedFilter.reset();
    this.bypassFilter.reset();
    this.badgesFilter.reset();
    this.sortBy.reset();
    this.typeFilter.reset();
    this.nbRoomsFilter.reset();
    this.colocSizeFilter.reset();
    this.minDurationFilter.reset();
    this.bathroomFilter.reset();
    this.wcFilter.reset();
    this.genderFilter.reset();
    this.chargesFilter.reset();
    this.dateRange.reset();
    this.photoFilter.reset();
    this.featuredFilter.reset();
    this.countryFilter.reset();
    this.dispoFilter = null;
    this.doFilter();
  }

  openModal(content, ppty) {
    this.isLoading = true;
    this.editPpty = ppty;
    this.otherRooms = [];
    this.adminProcessService.getHouseProperties(ppty.id).subscribe((data) => {
      data.forEach(d => {
        let ppty = this.fetchInfo(d);
        this.otherRooms.push(ppty);
      });
      this.otherRooms.push(this.editPpty);
      this.otherRooms = this.otherRooms.sort((a, b) => a.name > b.name ? 1 : a.name === b.name ? 0 : -1);

    });
    this.propertyPhotosList = [];
    this.editPpty.propertyPhotos = [];
    if (this.editPpty.virtualVisit) {
      this.editPpty.virtualVisit = this.sanitizer.bypassSecurityTrustHtml(this.editPpty.virtualVisit);
    }
    this.processSharedService.getPropertyPhotos(this.editPpty.id).subscribe(
      (data) => {
        const url = this.editPpty.cover_photo.split('/');
        const result = Object.entries(data);
        result.map(element => {
          const regex = /https/gi;
          if (element[1].photo.search(regex) !== -1) {
            this.editPpty.propertyPhotos.push(element[1].photo);
            this.editPpty.coverPhotoId = element[1].id;
          } else {
            url[url.length - 1] = element[1].photo;
            this.editPpty.propertyPhotos.push(url.join('/'));
          }
        });
        this.propertyPhotosList = data;
        this.isLoading = false;
      });
    this.modalService.open(content, {size: 'xl', centered: true});
  }

  openModalb(content, ppty) {
    this.ppties = [];
    this.resetModalB();
    this.ppties.push(ppty.id);
    const today = new Date();
    const forceBlockedDatas = ppty.forceBlocked_datas ? ppty.forceBlocked_datas : null;
    if (forceBlockedDatas) {
      if (forceBlockedDatas.typeOfBlock) {
        const listTypeOfBlock = forceBlockedDatas.typeOfBlock.split(', ');
        this.photoChecked = !!listTypeOfBlock.includes('Photo');
        this.infosChecked = !!listTypeOfBlock.includes('Infos');
        this.dispoChecked = !!listTypeOfBlock.includes('Dispo');
        this.travauxChecked = !!listTypeOfBlock.includes('Travaux');
        this.notFoundChecked = !!listTypeOfBlock.includes('404');
        this.autreChecked = !!listTypeOfBlock.includes('Autre');
      }
    }
    this.selectedDate = ppty.forceBlocked ? ppty.forceBlocked : null;
    this.commentaire = forceBlockedDatas ? forceBlockedDatas.blockCommentary : ' ';
    this.modalService.open(content, {size: 'lg', centered: true});
  }

  resetModalB() {
    this.photoChecked = false;
    this.infosChecked = false;
    this.dispoChecked = false;
    this.travauxChecked = false;
    this.notFoundChecked = false;
    this.autreChecked = false;
    this.selectedDate = null;
    this.commentaire = '';
  }

  isValidB() {
    return (this.selectedDate !== null && this.selectedDate !== '') &&
      (this.photoChecked !== false ||
        this.infosChecked !== false ||
        this.dispoChecked !== false ||
        this.travauxChecked !== false ||
        this.notFoundChecked !== false ||
        this.autreChecked !== false);

  }


  openSelectionModalb(content) {
    this.ppties = [];
    this.resetModalB();
    this.selectedElements.forEach((selectedElement) => {
      this.ppties.push(selectedElement.id);
    });
    this.modalService.open(content, {size: 'xl', centered: true});
  }

  isValidBypass() {
    return (this.bypassDate !== null && this.bypassDate !== '') &&
      (
        (this.dispoDate !== null && this.dispoDate !== undefined && this.dispoDate !== '') ||
        (this.bLoyer !== null && this.bLoyer !== undefined && this.bLoyer !== '') ||
        (this.bHono !== null && this.bHono !== undefined && this.bLoyer !== '') ||
        (this.bCharges !== null && this.bCharges !== undefined && this.bLoyer !== '') ||
        (this.partnerFees !== null && this.partnerFees !== undefined && this.bLoyer !== '') ||
        (this.deposit !== null && this.deposit !== undefined && this.bLoyer !== '')
      );
  }

  isValidSelectionBypass() {
    return (this.bypassDate !== null && this.bypassDate !== '');
  }

  openModalbypass(content, ppty) {
    this.ppties = [];
    this.ppties.push(ppty.id);
    this.dispoDate = ppty.disponibility ? ppty.disponibility.split(' ')[0] : '';
    let bypassDatas = ppty.bypassDatas ? ppty.bypassDatas : null;
    this.bypassDate = ppty.bypass_feed ? ppty.bypass_feed : '';
    if (this.bypassDate != null && bypassDatas) {
      this.bypassCommentary = bypassDatas.bypassCommentary ? bypassDatas.bypassCommentary : '';
    }
    this.modalService.open(content, {size: 'lg', centered: true});
  }

  openModalSelectionbypass(content) {
    this.ppties = [];
    this.selectedElements.forEach((selectedElement) => {
      this.ppties.push(selectedElement.id);
    });

    this.dispoDate = '';
    this.bypassDate = '';
    this.bypassCommentary = '';
    this.modalService.open(content, {size: 'lg', centered: true});
  }

  validateByPass() {
    let tenantData = null;
    let statusData = 'Listed';
    const options = [
      {label: 'Dispo', completed: this.dispoDate},
      {label: 'Loyer', completed: this.bLoyer},
      {label: 'Honoraires', completed: this.bHono},
      {label: 'Charges', completed: this.bCharges},
      {label: 'Frais partenaire', completed: this.partnerFees},
      {label: 'Dépôt garantie', completed: this.deposit},
    ];

    this.type = options
      .filter(option => option.completed)
      .map(option => option.label);

    const typeString = this.type.join(', ');
    let bypassDatas =
      {
        'typeOfBypass': typeString,
        'bypassCommentary': this.bypassCommentary,
        'bypassBy': {'id': this.currentAgent.id, 'lastname': this.currentAgent.lastname, 'firstname': this.currentAgent.firstname}
      };

    this.updateByPassList(bypassDatas);
    if (!this.dispoDate) {
      statusData = 'Unlisted';
    }

    const updateObject = {
      status: statusData,
      disponibility: this.dispoDate,
      price: this.bLoyer,
      reservation_fees: this.bHono,
      charges_amount: this.bCharges,
      partner_fees: this.partnerFees,
      deposit: this.deposit,
      bypass_feed: this.bypassDate,
      bypassDatas: bypassDatas,
      tenant: tenantData,
    };


    if (this.eraseTanent) {
      delete updateObject.tenant;
    }

    this.ppties.forEach(ppty => {
      this.adminProcessService.updatePropertyFields(ppty, updateObject).subscribe((data) => {
        const index = this.displayedProperties.findIndex(prop => prop.id === data.property.id);
        if (index !== -1) {
          this.displayedProperties[index].disponibility = this.dispoDate;
          this.displayedProperties[index].bLoyer = data.property.bLoyer;
          this.displayedProperties[index].bHono = data.property.bHono;
          this.displayedProperties[index].bCharges = data.property.bCharges;
          this.displayedProperties[index].partnerFees = data.property.partnerFees;
          this.displayedProperties[index].deposit = data.property.deposit;
          this.displayedProperties[index].tanent = data.property.tanent;
          this.displayedProperties[index].bypass_feed = data.property.bypass_feed;
          this.displayedProperties[index].bypassDatas = data.property.bypassDatas;
          this.displayedProperties[index].status = data.property.status;
        }
        this.tabUpdate(this.displayedProperties);
        this.modalService.dismissAll();
      });
    });

  }

  cancelBypass() {
    let statusData = 'Listed';

    let bypassDatas =
      {
        'typeOfBypass': '',
        'bypassCommentary': 'Bypass annulé',
        'bypassBy': {'id': this.currentAgent.id, 'lastname': this.currentAgent.lastname, 'firstname': this.currentAgent.firstname}
      };

    const updateObject = {
      bypass_feed: null,
      status: statusData,
      bypassDatas: bypassDatas,
    };

    this.ppties.forEach(ppty => {
      this.adminProcessService.updatePropertyFields(ppty, updateObject).subscribe((data) => {
        const index = this.displayedProperties.findIndex(prop => prop.id === data.property.id);
        if (index !== -1) {
          this.displayedProperties[index].bypass_feed = data.property.bypass_feed;
          this.displayedProperties[index].bypassDatas = data.property.bypassDatas;
          this.displayedProperties[index].status = data.property.status;
        }
        this.tabUpdate(this.displayedProperties);
      });
    });
    this.modalService.dismissAll();
  }

  setDate() {
    this.selectedDate = '2222-12-12';
  }

  setDateB() {
    this.bypassDate = '2222-12-12';
  }

  validate() {

    const options = [
      {label: 'Photo', checked: this.photoChecked},
      {label: 'Dispo', checked: this.dispoChecked},
      {label: 'Infos', checked: this.infosChecked},
      {label: 'Travaux', checked: this.travauxChecked},
      {label: '404', checked: this.notFoundChecked},
      {label: 'Autre', checked: this.autreChecked}
    ];

    this.type = options
      .filter(option => option.checked)
      .map(option => option.label);

    const typeString = this.type.join(', ');

    let forceBlockedDatas =
      {
        'typeOfBlock': typeString ? typeString : null,
        'blockCommentary': this.commentaire ? this.commentaire : null,
        'blockedBy': {'id': this.currentAgent.id, 'lastname': this.currentAgent.lastname, 'firstname': this.currentAgent.firstname}
      };

    let updateObject = {};

    if (this.selectedDate <= this.currentDate) {
      updateObject = {
        forceBlocked: null,
        forceBlocked_datas: null,
        status: 'Listed',
      };
    } else {
      updateObject = {
        forceBlocked: this.selectedDate,
        forceBlocked_datas: forceBlockedDatas,
        status: 'Unlisted',
      };
    }

    this.ppties.forEach(ppty => {
      this.adminProcessService.updatePropertyFields(ppty, updateObject).subscribe((data) => {
        const index = this.displayedProperties.findIndex(prop => prop.id === data.property.id);
        if (index !== -1) {
          this.displayedProperties[index].forceBlocked = data.property.forceBlocked;
          this.displayedProperties[index].forceBlocked_datas = data.property.forceBlocked_datas;
          this.displayedProperties[index].status = data.property.status;
        }
      });
    });


    this.tabUpdate(this.displayedProperties);
    this.updateBlockByList(forceBlockedDatas);
    this.modalService.dismissAll();
    this.resetModalB();
  }

  resetMultiplePhotos(elements: any[]) {
    // Ouvrir la modal de chargement avec les options `backdrop: 'static'` et `keyboard: false`
    this.loadingModalRef = this.modalService.open(this.loadingModal, {size: 'md', centered: true, backdrop: 'static', keyboard: false});

    // Réinitialiser les valeurs à zéro
    this.progressValue = 0;
    this.isResettingPhotos = true;
    this.propertyPhotosList = [];

    const propertyIds = elements.map(element => element.id);
    this.pptiesIds = [];
    this.pptiesIds.push(...propertyIds);

    const totalProperties = propertyIds.length;
    let processedProperties = 0;
    let isprogress = false;

    this.adminProcessService.resetMultiplePhotos(this.pptiesIds).subscribe(
      resetData => {
        isprogress = true;
        propertyIds.forEach(propertyId => {
          this.processSharedService.getPropertyPhotos(propertyId).subscribe(
            propertyData => {
              const property = elements.find(element => element.id === propertyId);
              if (property) {
                const urlParts = property.cover_photo.split('/');
                const dataEntries = Object.entries(propertyData);
                property.propertyPhotos = [];

                dataEntries.forEach(([key, value]) => {
                  const isHttpsPhoto = /https/gi.test(value.photo);

                  if (isHttpsPhoto) {
                    property.propertyPhotos.push(value.photo);
                    property.coverPhotoId = value.id;
                  } else {
                    urlParts[urlParts.length - 1] = value.photo;
                    property.propertyPhotos.push(urlParts.join('/'));
                  }
                });

                this.propertyPhotosList = resetData;
              }

              // Mise à jour de la progression
              processedProperties++;
              this.progressValue = (processedProperties / totalProperties) * 100;

              // Vérification si tous les éléments ont été traités pour fermer la modal
              if (processedProperties === totalProperties) {
                this.alertService.openSnackBar('Les photos ont été correctement mises à jour', 'snack-success');
                this.isResettingPhotos = false;
                this.loadingModalRef.close();
              }
            },
            error => {
              this.alertService.openSnackBar('Erreur lors de la récupération des photos mises à jour', 'snack-error');
              this.isResettingPhotos = false;
              this.loadingModalRef.close(); // Fermer la modal en cas d'erreur
            }
          );
        });
      },
      error => {
        this.isResettingPhotos = false;
        this.alertService.openSnackBar('Erreur lors de la réinitialisation des photos', 'snack-error');
        this.loadingModalRef.close(); // Fermer la modal en cas d'erreur
      }
    );

    // Écouter l'événement de fermeture de la modal pour réinitialiser les valeurs
    this.loadingModalRef.closed.subscribe(() => {
      this.progressValue = 0;
    });
  }

  splitName(name) {
    const split = name.split('-');
    return split[split.length - 1];
  }

  deblock() {

    let forceBlockedDatas =
      {
        'typeOfBlock': 'débloquer le ' + this.currentDate,
        'blockCommentary': '',
        'blockedBy': {'id': this.currentAgent.id, 'lastname': this.currentAgent.lastname, 'firstname': this.currentAgent.firstname}
      };

    let statusData = 'Unlisted';
    const today = new Date();


    if ((this.dispoDate) && new Date(this.bypassDate) <= today) {
      statusData = 'Listed';
    }

    const updateObject = {
      forceBlocked: null,
      forceBlocked_datas: forceBlockedDatas,
      status: statusData,
    };

    this.ppties.forEach(ppty => {
      this.adminProcessService.updatePropertyFields(ppty, updateObject).subscribe((data) => {
        const index = this.displayedProperties.findIndex(prop => prop.id === data.property.id);
        if (index !== -1) {
          this.displayedProperties[index].forceBlocked = data.property.forceBlocked;
          this.displayedProperties[index].forceBlocked_datas = data.property.forceBlocked_datas;
          this.displayedProperties[index].status = data.property.status;
        }
      });
    });

    this.tabUpdate(this.displayedProperties);
    this.modalService.dismissAll();
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  private _reorderItem(fromIndex, toIndex): void {
    const direction = toIndex.serial < fromIndex.serial ? 1 : -1;
    const temp = toIndex.serial;
    toIndex.serial += direction;
    fromIndex.serial = temp;

    this.propertyPhotosList.forEach(photo => {
      if (photo.serial >= fromIndex.serial && photo.serial <= toIndex.serial) {
        photo.serial += direction;
      }
    });
    this.sortPhotos();
  }

  onDragStart(photo): void {
    this.draggingIndex = photo;
  }

  onDragEnter(photoTo): void {
    if (this.draggingIndex.id !== photoTo.id) {
      this._reorderItem(this.draggingIndex, photoTo);
    }
  }

  onDragEnd(): void {
    this.draggingIndex = undefined;
  }

  sortPhotos() {
    if (this.propertyPhotosList) {
      return this.propertyPhotosList.sort((a, b) => a.serial > b.serial ? 1 : a.serial === b.serial ? 0 : -1);
    }
  }

  setCoverPhoto(photo, ppty) {
    this.propertyPhotosList.forEach(element => {
      element.cover_photo = 0;
    });
    photo.cover_photo = 1;
    ppty.cover_photo = photo.photo;
  }

  deletePhoto(photo) {
    this.adminProcessService.deletePropertyPhoto(photo).subscribe((d) => {
      this.processSharedService.getPropertyPhotos(this.editPpty.id).subscribe(
        (data) => {
          const url = this.editPpty.cover_photo.split('/');
          const result = Object.entries(data);
          this.editPpty.propertyPhotos = [];
          result.map(element => {
            const regex = /https/gi;
            if (element[1].photo.search(regex) !== -1) {
              this.editPpty.propertyPhotos.push(element[1].photo);
              this.editPpty.coverPhotoId = element[1].id;
            } else {
              url[url.length - 1] = element[1].photo;
              this.editPpty.propertyPhotos.push(url.join('/'));
            }

          });
          this.propertyPhotosList = data;
        });

    });
  }

  deleteSelectionPhoto() {
    this.selectedPhotos.forEach(photo => {
      this.deletePhoto(photo.id);
    });
    this.alertService.openSnackBar('Les photos sélectionnées ont bien étés supprimées', 'snack-success');

    this.selectedPhotos = [];
  }

  updatePhotos() {
    this.adminProcessService.setPropertyPhotos({photos: this.propertyPhotosList}).subscribe(
      () => {
        this.modalService.dismissAll();
        this.alertService.openSnackBar('Les photos ont étés correctement mises à jour', 'snack-success');
      }
    );
  }

  onFileSelected(event, row) {
    const files: File[] = event.target.files;
    const currentUser = this.authenticationService.currentUserValue;
    const httpOptions: object = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${currentUser.token}`
      }),
      reportProgress: true,
    };
    if (files.length !== 0) {
      const formData = new FormData();
      if (row) {
        formData.append('img', files[0]);
        formData.append('id', this.uploadId);
        const req = new HttpRequest('POST', `${this.apiUrl}care/updatePropertyPict`, formData, httpOptions);
        const upload$ = this.http.request(req);
        upload$.subscribe((data: any) => {
          if (data && data.body && data.body.filename) {
            row.photo = data.body.filename;
            if (row.cover_photo) {
              this.editPpty.cover_photo = data.body.filename;
            }
            this.alertService.openSnackBar('Les photos ont été correctement mise à jour', 'snack-success');
          }
        });
      }
      if (!row) {
        for (let index = 0; index < files.length; index++) {
          formData.append('img' + index, files[index]);
        }
        formData.append('count', files.length.toString());
        formData.append('property_id', this.editPpty.id);
        const req = new HttpRequest('POST', `${this.apiUrl}care/addPropertyPict`, formData, httpOptions);
        const upload$ = this.http.request(req);
        upload$.subscribe((data: any) => {
          if (data && data.body) {
            this.processSharedService.getPropertyPhotos(this.editPpty.id).subscribe(
              (data) => {
                const url = this.editPpty.cover_photo.split('/');
                const result = Object.entries(data);
                this.editPpty.propertyPhotos = [];
                result.map(element => {
                  const regex = /https/gi;
                  if (element[1].photo.search(regex) !== -1) {
                    this.editPpty.propertyPhotos.push(element[1].photo);
                    this.editPpty.coverPhotoId = element[1].id;
                  } else {
                    url[url.length - 1] = element[1].photo;
                    this.editPpty.propertyPhotos.push(url.join('/'));
                  }
                });
                this.propertyPhotosList = data;
                this.alertService.openSnackBar('Les photos ont été correctement mise à jour', 'snack-success');
              });
          }
        });
      }
    }
  }


  updatePropertyField(id, field, value) {
    this.editPpty[field] = value;
    this.adminProcessService.updatePropertyField(id, field, value).subscribe();
  }

  copyText(content, isProperty) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = isProperty ? document.location.origin + '/en/accommodation/property/' + content.id : content.link;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  getSubCityList(ppties) {
    let d = [];
    let d2 = [];
    ppties.forEach(element => {
      if (!d.includes(element.city_id)) {
        d.push(element.city, element.city_id);
      }
    });
    d.forEach(element => {
      if (typeof element === 'string') {
        d2.push({value: element, label: element});
      }
    });
    return d2;
  }

  setChargesFilters() {
    this.selectedChargesFilters = this.chargesList.filter(item => item.checked);
  }


  isChecked(type, element: any): boolean {
    if (type == 'photo') {
      return this.selectedPhotos.some(selectedPhoto => selectedPhoto.id === element.id);
    } else {
      return this.selectedElements.some(selectedElement => selectedElement.id === element.id);
    }
  }

  toggleCheckbox(type, checked: boolean, element: any) {
    if (type == 'photo') {
      if (checked) {
        this.selectedPhotos.push(element);
      } else {
        const index = this.selectedPhotos.findIndex(selectedPhoto => selectedPhoto.id === element.id);
        if (index !== -1) {
          this.selectedPhotos.splice(index, 1);
        }
      }
    } else {
      if (checked) {
        this.selectedElements.push(element);
      } else {
        const index = this.selectedElements.findIndex(selectedElement => selectedElement.id === element.id);
        if (index !== -1) {
          this.selectedElements.splice(index, 1);
        }
      }
    }
  }

  selectAllItems() {
    if (this.selectAll) {
      const startIndex = this.paginator.pageIndex * this.paginator.pageSize;
      const endIndex = startIndex + this.paginator.pageSize;

      this.displayedProperties.slice(startIndex, endIndex).forEach(element => {
        this.toggleCheckbox('property', true, element);
      });
    } else {

      this.displayedProperties.forEach(element => {
        this.toggleCheckbox('property', false, element);
      });
      this.selectedElements = [];
    }
  }

  selectAllPhotos() {
    if (this.selectPhotos) {
      this.propertyPhotosList.forEach(element => {
        this.toggleCheckbox('photo', true, element);
      });
    } else {
      this.propertyPhotosList.forEach(element => {
        this.toggleCheckbox('photo', false, element);
      });
      this.selectedPhotos = [];
    }
  }


  copyToClipboard() {
    if (this.selectedElements) {
      const textToCopy = this.selectedElements.map(element => {
        const link = `https://livin-france.com/en/accommodation/property/${element.id}`;
        const loyer = element.price + element.charges_amount;
        return `${loyer}€ - ${element.city} - ${link}`;
      }).join('\n\n');

      const textArea = document.createElement('textarea');
      textArea.value = textToCopy;

      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
    }
  }

  // @TODO : Opti pour éviter sub dans sub
  resetPhotos(property) {
    this.isResettingPhotos = true;
    this.adminProcessService.resetPhotos(property.id).subscribe(
      data => {
        this.processSharedService.getPropertyPhotos(property.id).subscribe(
          (data) => {
            const url = property.cover_photo.split('/');
            const result = Object.entries(data);
            property.propertyPhotos = [];
            result.map(element => {
              const regex = /https/gi;
              if (element[1].photo.search(regex) !== -1) {
                property.propertyPhotos.push(element[1].photo);
                property.coverPhotoId = element[1].id;
              } else {
                url[url.length - 1] = element[1].photo;
                property.propertyPhotos.push(url.join('/'));
              }

            });
            this.propertyPhotosList = data;
            this.isResettingPhotos = false;
          });
        this.alertService.openSnackBar('Les photos ont étés correctement mises à jour', 'snack-success');
      }
    );
  }

  downloadSelectionPhoto() {
    this.selectedPhotos.forEach(photo => {
      this.helperService.downloadFile(photo.photo);
    });
  }

  validateBadge(reverse?: boolean) {
    let updateObject;
    let promotionDatas = null;
    let badgesData = null;

    if(!reverse){
      if (this.badgeSelected !== null && this.badgeSelected !== 'null') {
        badgesData =
          {
            'isLocated': 0,
            'isPopular': 0,
            'isPromoted': 0
          };
        let value = this.badgeSelected;
        badgesData[value] = 1;

        if (value == 'isPromoted') {
          promotionDatas = {
            'startDate': this.startDatePromo,
            'endDate': this.endDatePromo,
            'typeReduction': this.typeReduc,
            'typePromo': this.typePromoFC.value,
            'reduction': this.promoReduc
          };
        }
      }
    }
    else {
      this.isFeatured = false;
    }

    updateObject = {
      badges: badgesData,
      promotionDatas: promotionDatas,
      is_featured: this.isFeatured
    };

    // @TODO : voir sur le long terme s'il faut optimiser
    this.ppties.forEach(ppty => {
      this.adminProcessService.updatePropertyFields(ppty, updateObject).subscribe((data) => {
        const index = this.displayedProperties.findIndex(prop => prop.id === data.property.id);
        if (index !== -1) {
          this.displayedProperties[index].badges = data.property.badges;
          this.displayedProperties[index].promotionDatas = data.property.promotionDatas;
        }
        this.tabUpdate(this.displayedProperties);
        this.isFeatured = false;
        this.modalService.dismissAll();
      });
    });
  }



  changeBadgeSelected(badge) {
    this.badgeSelected = badge.value;
  }

  openModalBadge(content, ppty) {
    this.ppties = [];
    this.ppties.push(ppty.id);
    this.isFeatured = ppty.is_featured;
    this.badgeSelected = 'null';
    this.badgeFC.setValue('null');

    if (ppty.badges) {
      Object.keys(ppty.badges).forEach(e => {
        if (ppty.badges[e]) {
          this.badgeSelected = e;
          this.badgeFC.setValue(e);
        }
      });
      if (this.badgeSelected === 'isPromoted') {
        this.typePromoFC.setValue(ppty.promotionDatas.typePromo);
        this.typeReduc = ppty.promotionDatas.typeReduction;
        this.promoReduc = ppty.promotionDatas.reduction;
        this.startDatePromo = ppty.promotionDatas.startDate;
        this.endDatePromo = ppty.promotionDatas.endDate;
      }
    }
    this.modalService.open(content, {size: 'lg', centered: true});
  }

  openModalBadgeSelection(content) {
    this.ppties = [];
    this.selectedElements.forEach((selectedElement) => {
      this.ppties.push(selectedElement.id);
    });

    this.modalService.open(content, {size: 'lg', centered: true});
  }

  changeRoom(ppty) {
    this.isLoading = true;
    this.editPpty = ppty;
    ppty.photosVerified = this.convertPhotosVerified(ppty.photosVerified);
    this.propertyPhotosList = [];
    this.editPpty.propertyPhotos = [];
    if (this.editPpty.virtualVisit) {
      this.editPpty.virtualVisit = this.sanitizer.bypassSecurityTrustHtml(this.editPpty.virtualVisit);
    }
    this.processSharedService.getPropertyPhotos(this.editPpty.id).subscribe(
      (data) => {
        const url = this.editPpty.cover_photo.split('/');
        const result = Object.entries(data);
        result.map(element => {
          const regex = /https/gi;
          if (element[1].photo.search(regex) !== -1) {
            this.editPpty.propertyPhotos.push(element[1].photo);
            this.editPpty.coverPhotoId = element[1].id;
          } else {
            url[url.length - 1] = element[1].photo;
            this.editPpty.propertyPhotos.push(url.join('/'));
          }
        });
        this.propertyPhotosList = data;
        this.isLoading = false;
      });
  }

  public convertPhotosVerified(value) {
    if (value === '0') {
      return 'null';
    }
    if (value === '1') {
      return 'verified';
    }
    return value;
  }

  openVVLink(iframe) {
    const url = this.helperService.extractIframeSrc(iframe);
    window.open(url, '_blank');
  }

  IsPptyVerified(ppty) {
    if (
      !ppty.virtualVisitVerified ||
      ppty.photosVerified !== 'verified' ||
      !ppty.wcVerified ||
      !ppty.bathroomVerified ||
      (ppty.wc_private == 0 && !ppty.nbWc) ||
      (ppty.bathrooms_private == 0 && !ppty.nbBathroom)
    ) {
      return 0;
    } else {
      return 1;
    }

  }

  download(url): void {
    this.helperService
      .download(url)
      .subscribe(blob => saveAs('https://livinfrance-staging-bk.s3.eu-west-3.amazonaws.com/media/92/1537452310_img_maison_196_2249.jpg', 'test.png'));
  }

  onDateChange(event) {
    this.editPpty.disponibility = event;
  }

  private updateBlockByList(forceBlockDatas): void {
    if (forceBlockDatas.blockedBy) {
      if (this.blockByList.length === 0 || !this.blockByList.find(a => a.id === forceBlockDatas.blockedBy.id)) {
        this.blockByList.push(forceBlockDatas.blockedBy);
      }
    }
  }

  private updateByPassList(byPassDatas): void {
    if (byPassDatas.bypassBy) {
      if (this.byPassList.length === 0 || !this.byPassList.find(a => a.id === byPassDatas.bypassBy.id)) {
        this.byPassList.push(byPassDatas.bypassBy);

      }
    }

  }

  scrollToTop(): void {
    const page_listener = document.querySelector('.page_listener');
    page_listener.scrollTo(0, 0);
  }

  scrollToBottom(): void {
    const page_listener = document.querySelector('.page_listener');
    const scrollHeight = page_listener.scrollHeight;
    page_listener.scrollTo(0, scrollHeight);
  }


  protected readonly length = length;
}
